import { __awaiter } from "tslib";
import apiClient, { getApiHeaders } from './apiClient';
const searchCompaniesByName = (companyData) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield apiClient.post('/api/lusha-prospecting/companies', companyData, {
        headers: getApiHeaders(),
    });
    return data;
});
const searchEmployeesByCompany = (companyData) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield apiClient.post('/api/lusha-prospecting/employees', companyData, {
        headers: getApiHeaders(),
    });
    return data;
});
export { searchCompaniesByName, searchEmployeesByCompany };
